// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__AUtZZ","text":"tab_text__EYY3M","loader":"tab_loader__Qssj+","rotate":"tab_rotate__bsg6w","tab--loading":"tab_tab--loading__Stz+y"};